import authenticatedHttpClientFactory from '@/modules/core/services/authenticatedHttpClientFactory';
export const getClientes = async() => {
  const httpClient = authenticatedHttpClientFactory();
  const response = await httpClient.get('clientes');
  return response.data;
};
export const getServicos = async() => {
  const httpClient = authenticatedHttpClientFactory();
  const response = await httpClient.get('servicos');
  return response.data;
};
export const getUsers = async() => {
  const httpClient = authenticatedHttpClientFactory();
  const response = await httpClient.get('usuarios');
  return response.data;
};
